import {useSyncExternalStore} from 'react';

// Module-scoped filter store (global-filter-store-pattern, FNP-815): the filter drawer,
// the badge on its button and the list hook are siblings, so the filter lives here rather
// than in any one component.
//
// Read through useSyncExternalStore, not a useState snapshot plus a useEffect subscribe
// (FNP-605): a change that landed between a component's first render and its effect was
// lost, and that component kept rendering the stale filter.
//
// Defaults to Active subscriptions: the index opened that way before this store was
// rewritten.
export const DEFAULT_CUSTOMER_SUBSCRIPTIONS_FILTERS: Record<string, string> = {status: 'Active'};

let currentFilters: Record<string, string> = DEFAULT_CUSTOMER_SUBSCRIPTIONS_FILTERS;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

const getSnapshot = () => currentFilters;

const setFilters = (filters: Record<string, string>) => {
    currentFilters = filters;
    listeners.forEach(listener => listener());
};

// Tests only: the store outlives a test case otherwise.
export const resetCustomerSubscriptionsFilters = () => setFilters(DEFAULT_CUSTOMER_SUBSCRIPTIONS_FILTERS);

export const useCustomerSubscriptionsFilter = () => {
    const filters = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

    return {
        filters,
        handleSetFilters: (newFilters: Record<string, string>) => setFilters(newFilters),
        handleClearFilters: () => setFilters({}),
    };
};
